(function () {
	$('input').on('click', e => {
		if (e.currentTarget.name === 'SelektierteNewsletterIds') {
			$('#AlleNewsletterEntfernen')[0].checked = false;
		} else if (e.currentTarget.id === 'AlleNewsletterEntfernen') {
			$('input[name="SelektierteNewsletterIds"]').each((i, ele) => {
				ele.checked = false;
			});
		}
	});
})();
